import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ECOM_PLATFORM_APP_DEF_ID, SPECS } from './consts';
export class ViewerContext {
  constructor(controllerConfig) {
    this.controllerConfig = controllerConfig;
    _defineProperty(this, "ecomPlatformInstance", '');
    this.ecomPlatformInstance = controllerConfig.appParams.instance;
    controllerConfig.wixCodeApi.site.onInstanceChanged(_ref => {
      let {
        instance
      } = _ref;
      this.ecomPlatformInstance = instance;
    }, ECOM_PLATFORM_APP_DEF_ID);
  }
  isExperimentEnabled(key) {
    return this.controllerConfig.essentials.experiments.enabled(key);
  }
  isSSR() {
    return this.controllerConfig.wixCodeApi.window.rendering.env === 'backend';
  }
  getDeviceType() {
    return this.controllerConfig.wixCodeApi.window.formFactor;
  }
  getViewMode() {
    return this.controllerConfig.wixCodeApi.window.viewMode;
  }
  getVisitorId() {
    var _this$controllerConfi;
    return (_this$controllerConfi = this.controllerConfig.platformAPIs.bi) == null ? void 0 : _this$controllerConfi.visitorId;
  }
  isPrimaryLanguage() {
    const currentLang = this.controllerConfig.wixCodeApi.window.multilingual.siteLanguages.find(lang => lang.languageCode === this.controllerConfig.wixCodeApi.window.multilingual.currentLanguage);
    return !currentLang || currentLang.isPrimaryLanguage;
  }
  getCurrentLanguage() {
    if (this.controllerConfig.wixCodeApi.window.multilingual.isEnabled) {
      return this.controllerConfig.wixCodeApi.window.multilingual.currentLanguage.split('-')[0];
    }
    return this.controllerConfig.wixCodeApi.site.language || 'en';
  }
  getEcomPlatformInstance() {
    return this.ecomPlatformInstance;
  }
  getEcomPlatformInstanceId() {
    return this.controllerConfig.appParams.instanceId;
  }
  getEcomPlatformPublicAPI() {
    return this.controllerConfig.wixCodeApi.site.getPublicAPI(ECOM_PLATFORM_APP_DEF_ID);
  }
  async getSectionUrl(sectionId) {
    const section = await this.getSectionUrlConfig(sectionId);
    return section == null ? void 0 : section.url;
  }
  async navigateToSection(sectionId, queryParams, entityId) {
    const sectionUrlConfig = await this.getSectionUrlConfig(sectionId);
    if (!(sectionUrlConfig != null && sectionUrlConfig.relativeUrl) || !this.controllerConfig.wixCodeApi.location.to) {
      throw new Error(`Can't navigate to ${sectionId}`);
    }
    const url = new URL(sectionUrlConfig.relativeUrl, 'https://dummy');
    Object.entries(queryParams || {}).forEach(_ref2 => {
      let [key, value] = _ref2;
      return url.searchParams.append(key, value);
    });
    const finalPathname = entityId ? `${url.pathname}/${entityId}` : url.pathname;
    return this.controllerConfig.wixCodeApi.location.to(finalPathname + url.search);
  }
  getSectionUrlConfig(sectionId) {
    const params = {
      sectionId,
      appDefinitionId: ECOM_PLATFORM_APP_DEF_ID
    };
    return this.controllerConfig.wixCodeApi.site.getSectionUrl(params, false);
  }
  getLinkUrl(link) {
    var _this$controllerConfi2;
    return (_this$controllerConfi2 = this.controllerConfig.platformAPIs.links) == null ? void 0 : _this$controllerConfi2.toUrl(link);
  }
  navigateToUrl(url) {
    this.controllerConfig.wixCodeApi.location.to(url);
  }
  async getHomepageUrl() {
    if (this.isExperimentEnabled(SPECS.FixCartNavigationOnPreview)) {
      const siteStructure = await this.controllerConfig.wixCodeApi.site.getSiteStructure({
        includePageId: true,
        shouldNotFilterOutHiddenPages: true
      });
      const page = siteStructure.pages.find(p => p.isHomePage) ?? {
        url: '/'
      };
      return page.url;
    }
    return this.controllerConfig.wixCodeApi.location.baseUrl;
  }
}
//# sourceMappingURL=ViewerContext.js.map